// extracted by mini-css-extract-plugin
export default {"link":"logo_link__34-pq","img":"logo_img__7YX7J"};